import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AffiliateInputProps {
  defaultValue: number;
  onSave: (value: number) => Promise<void>;
  isFetching: boolean;
}
export const AffiliatePayoutInput = t0 => {
  const $ = _c(20);
  const {
    defaultValue,
    onSave,
    isFetching
  } = t0;
  const [value, setValue] = useState(0);
  const {
    t
  } = useLocoTranslation();
  let t1;
  let t2;
  if ($[0] !== defaultValue) {
    t1 = () => {
      setValue(defaultValue);
    };
    t2 = [defaultValue];
    $[0] = defaultValue;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = `focus-within:border-brand-primary main-transition-colors border-text-secondary/30 flex w-fit rounded-lg border ${isFetching && "bg-skeleton-primary/40 animate-pulse"}`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e => setValue(() => {
      const newValue = e.target.valueAsNumber;
      if (newValue > 100) {
        return 100;
      } else {
        if (newValue < 0) {
          return 0;
        }
      }
      return newValue;
    });
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onSave || $[5] !== value) {
    t5 = () => onSave(value);
    $[4] = onSave;
    $[5] = value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isFetching || $[8] !== t5 || $[9] !== value) {
    t6 = <input value={value} disabled={isFetching} type="number" onChange={t4} onBlur={t5} className="main-transition-colors text-text-primary focus:border-brand-primary placeholder:text-text-tertiary/70 peer w-[66px] rounded-lg px-4 py-2.5 focus:outline-hidden" />;
    $[7] = isFetching;
    $[8] = t5;
    $[9] = value;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t || $[12] !== value) {
    t7 = value > 1 ? t("dashboard.name_of_times.days.plural") : t("dashboard.name_of_times.days.one");
    $[11] = t;
    $[12] = value;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div className="bg-background-primary flex w-fit w-fit items-center justify-center rounded-r-lg px-4 py-2.5">{t7}</div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t6 || $[18] !== t8) {
    t9 = <div className={t3}>{t6}{t8}</div>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export const AffiliateCommissionInput = t0 => {
  const $ = _c(15);
  const {
    defaultValue,
    onSave,
    isFetching
  } = t0;
  const [value, setValue] = useState(0);
  let t1;
  let t2;
  if ($[0] !== defaultValue) {
    t1 = () => {
      setValue(defaultValue);
    };
    t2 = [defaultValue];
    $[0] = defaultValue;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = `focus-within:border-brand-primary main-transition-colors border-text-secondary/30 flex w-fit rounded-lg border ${isFetching && "bg-skeleton-primary/40 animate-pulse"}`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e => setValue(() => {
      const newValue = e.target.valueAsNumber;
      if (newValue > 100) {
        return 100;
      } else {
        if (newValue < 0) {
          return 0;
        }
      }
      return newValue;
    });
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onSave || $[5] !== value) {
    t5 = () => onSave(value);
    $[4] = onSave;
    $[5] = value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isFetching || $[8] !== t5 || $[9] !== value) {
    t6 = <input value={value} disabled={isFetching} type="number" onChange={t4} onBlur={t5} className="main-transition-colors text-text-primary focus:border-brand-primary placeholder:text-text-tertiary/70 peer w-[66px] rounded-lg px-4 py-2.5 focus:outline-hidden  " />;
    $[7] = isFetching;
    $[8] = t5;
    $[9] = value;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="bg-background-primary flex w-fit items-center justify-center rounded-r-lg px-4 py-2.5">%</div>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t6) {
    t8 = <div className={t3}>{t6}{t7}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};